// extracted by mini-css-extract-plugin
module.exports = {"heroImage":"banner_heroImage__1vuOz","title":"banner_title__U7sg1"};